import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
  reportTypes: string[];
  isAllUsers: boolean;
}

const initialState: InitialState = {
  reportTypes: [],
  isAllUsers: false,
};

const reportslice = createSlice({
  name: "report",
  initialState,
  reducers: {
    setReportTypes: (state, action: PayloadAction<string[]>) => {
      state.reportTypes = action.payload;
    },
    setAllusers: (state, action: PayloadAction<boolean>) => {
      state.isAllUsers = action.payload;
    },
  },
});

export const { setReportTypes, setAllusers } = reportslice.actions;
export default reportslice.reducer;
